import React, { useState, forwardRef, useImperativeHandle, useMemo ,useEffect} from 'react';
import { Cable } from 'lucide-react';
import { DashboardProject } from '../../../../types/project';
import type { SetupState1, PipelineSetupData, PipelinePipeSize, SetupState } from '../../../../types/setup';
import { CommonSetupForm } from './CommonSetupForm';

interface PipelineSetupProps {
  project: DashboardProject;
  manufacturingList: any[];
  setManufacturingList: React.Dispatch<React.SetStateAction<any[]>>;
  unit: string;
  setUnit: (unit: string) => void;
  showValidation?: boolean;
  setShowValidation?: React.Dispatch<React.SetStateAction<boolean>>;
  setupData?: any;
  state: SetupState1;
  setState: React.Dispatch<React.SetStateAction<SetupState1>>;
  setHasUnsavedChanges: (hasUnsavedChanges: boolean) => void;
  OnSave: (hasUnsavedChanges: boolean) => void;
  canEdit?: boolean;
}

export interface PipelineSetupRef {
  getSetupData: () => PipelineSetupData;
  
}

export const PipelineSetup = forwardRef<PipelineSetupRef, PipelineSetupProps>(({ project,
   manufacturingList,setManufacturingList,unit,setUnit, showValidation = false,setShowValidation,setupData, state, setState, setHasUnsavedChanges, OnSave, canEdit = true }, ref) => {




  //Expose setup data through ref
  useImperativeHandle(ref, () => ({
    getSetupData: () => {
      return {
        projectId: state?.projectId || 0,
        projectTypeId: state?.projectTypeId || 0,
        projectType: state?.projectType as 'pipeline' | 'fabrication' | 'others',
        projectSubType: state?.projectSubType || 'none',
        numberOfPipeSizes: state?.numberOfPipeSizes || 0,
        pipeSizes: state?.pipeSizes?.map(pipe => ({
          pipeId: pipe.pipeId,
          pipeName: pipe.pipeName,
          pipeSize: pipe.pipeSize,
          wallThickness: pipe.wallThickness,
          numberOfBuckleArrestors: pipe.numberOfBuckleArrestors,
          numberOfPipes: pipe.numberOfPipes,
          pipeLength: pipe.pipeLength,
          numberOfForges: pipe.numberOfForges,
          outputAssemblyLength: pipe.outputAssemblyLength,
          manufacturerId: pipe.manufacturerId,
          manufacturerIds: pipe.manufacturerIds,
          pipeOrder: pipe.pipeOrder,
          isActive: pipe.isActive,
          prefixAssemblyName: pipe.prefixAssemblyName,
          jobNumber: pipe.jobNumber,
          documentsData: pipe.documentsData
        })) || []
      };
    }
  }));

      return (
      <CommonSetupForm
        project={project}
        state={state as SetupState1}
        setState={setState as any}
        title="Pipeline"
        icon={<Cable className="h-5 w-5" />}
        iconColor="text-blue-800"
        manufacturingList={manufacturingList}
        setManufacturingList={setManufacturingList}
        unit={unit}
        setUnit={setUnit}
        showValidation={showValidation}
        setShowValidation={setShowValidation}
        setHasUnsavedChanges={setHasUnsavedChanges}
        // setupData={setupData} // Removed to fix type error
        OnSave={OnSave}
        canEdit={canEdit}
      />
    );
}); 